// Package tenancy.v3 defines the protocol buffer messages for tenancy management
// within the platform. This includes plans, ledger balances, and usage tracking.

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file tenancy/v3/tenancy.proto (package tenancy.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tenancy/v3/tenancy.proto.
 */
export const file_tenancy_v3_tenancy: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_v3_common]);

/**
 * Plan represents a tenancy plan for an organization
 *
 * @generated from message tenancy.v3.Plan
 */
export type Plan = Message<"tenancy.v3.Plan"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: tenancy.v3.PlanType type = 4;
   */
  type: PlanType;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp modified_at = 7;
   */
  modifiedAt: Timestamp;
};

/**
 * Describes the message tenancy.v3.Plan.
 * Use `create(PlanSchema)` to create a new message.
 */
export const PlanSchema: GenMessage<Plan> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 0);

/**
 * LedgerBalance represents the current credit balance for an organization
 *
 * @generated from message tenancy.v3.LedgerBalance
 */
export type LedgerBalance = Message<"tenancy.v3.LedgerBalance"> & {
  /**
   * Current credit balance
   *
   * @generated from field: int64 credits = 1;
   */
  credits: bigint;

  /**
   * @generated from field: int64 credits_used_this_period = 2;
   */
  creditsUsedThisPeriod: bigint;

  /**
   * @generated from field: int64 credits_added_this_period = 3;
   */
  creditsAddedThisPeriod: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated = 4;
   */
  lastUpdated: Timestamp;

  /**
   * @generated from field: repeated tenancy.v3.CreditExpiration expiring_credits = 5;
   */
  expiringCredits: CreditExpiration[];

  /**
   * @generated from field: google.protobuf.Timestamp period_start = 6;
   */
  periodStart: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp period_end = 7;
   */
  periodEnd: Timestamp;
};

/**
 * Describes the message tenancy.v3.LedgerBalance.
 * Use `create(LedgerBalanceSchema)` to create a new message.
 */
export const LedgerBalanceSchema: GenMessage<LedgerBalance> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 1);

/**
 * CreditExpiration represents credits that will expire at a specific time
 *
 * @generated from message tenancy.v3.CreditExpiration
 */
export type CreditExpiration = Message<"tenancy.v3.CreditExpiration"> & {
  /**
   * @generated from field: int64 credits = 1;
   */
  credits: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt: Timestamp;
};

/**
 * Describes the message tenancy.v3.CreditExpiration.
 * Use `create(CreditExpirationSchema)` to create a new message.
 */
export const CreditExpirationSchema: GenMessage<CreditExpiration> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 2);

/**
 * CreditTransaction represents a single credit or debit transaction
 *
 * @generated from message tenancy.v3.CreditTransaction
 */
export type CreditTransaction = Message<"tenancy.v3.CreditTransaction"> & {
  /**
   * Transaction ID (could be LedgerCredit or LedgerDebit)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: tenancy.v3.TransactionType type = 2;
   */
  type: TransactionType;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: tenancy.v3.DebitType debit_type = 5;
   */
  debitType: DebitType;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 6;
   */
  occurredAt: Timestamp;

  /**
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message tenancy.v3.CreditTransaction.
 * Use `create(CreditTransactionSchema)` to create a new message.
 */
export const CreditTransactionSchema: GenMessage<CreditTransaction> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 3);

/**
 * UsageSummary provides a summary of credit usage
 *
 * @generated from message tenancy.v3.UsageSummary
 */
export type UsageSummary = Message<"tenancy.v3.UsageSummary"> & {
  /**
   * DebitType -> credits used
   *
   * @generated from field: map<string, int64> usage_by_type = 1;
   */
  usageByType: { [key: string]: bigint };

  /**
   * @generated from field: int64 total_credits_used = 2;
   */
  totalCreditsUsed: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp period_start = 3;
   */
  periodStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp period_end = 4;
   */
  periodEnd?: Timestamp;
};

/**
 * Describes the message tenancy.v3.UsageSummary.
 * Use `create(UsageSummarySchema)` to create a new message.
 */
export const UsageSummarySchema: GenMessage<UsageSummary> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 4);

/**
 * TenancyInfo provides comprehensive tenancy information
 *
 * @generated from message tenancy.v3.TenancyInfo
 */
export type TenancyInfo = Message<"tenancy.v3.TenancyInfo"> & {
  /**
   * @generated from field: tenancy.v3.Plan plan = 1;
   */
  plan: Plan;

  /**
   * @generated from field: tenancy.v3.LedgerBalance balance = 2;
   */
  balance: LedgerBalance;

  /**
   * @generated from field: tenancy.v3.UsageSummary usage_summary = 3;
   */
  usageSummary: UsageSummary;
};

/**
 * Describes the message tenancy.v3.TenancyInfo.
 * Use `create(TenancyInfoSchema)` to create a new message.
 */
export const TenancyInfoSchema: GenMessage<TenancyInfo> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy, 5);

/**
 * PlanType defines the available plan types
 *
 * @generated from enum tenancy.v3.PlanType
 */
export enum PlanType {
  /**
   * @generated from enum value: PLAN_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_TYPE_FREE_V1 = 1;
   */
  FREE_V1 = 1,

  /**
   * @generated from enum value: PLAN_TYPE_PRO_V1 = 2;
   */
  PRO_V1 = 2,

  /**
   * @generated from enum value: PLAN_TYPE_TEAM_V1 = 3;
   */
  TEAM_V1 = 3,

  /**
   * @generated from enum value: PLAN_TYPE_POWER_USER_V1 = 4;
   */
  POWER_USER_V1 = 4,

  /**
   * @generated from enum value: PLAN_TYPE_PRO_V2 = 5;
   */
  PRO_V2 = 5,
}

/**
 * Describes the enum tenancy.v3.PlanType.
 */
export const PlanTypeSchema: GenEnum<PlanType> = /*@__PURE__*/
  enumDesc(file_tenancy_v3_tenancy, 0);

/**
 * TransactionType defines whether a transaction is a credit or debit
 *
 * @generated from enum tenancy.v3.TransactionType
 */
export enum TransactionType {
  /**
   * @generated from enum value: TRANSACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_TYPE_CREDIT = 1;
   */
  CREDIT = 1,

  /**
   * @generated from enum value: TRANSACTION_TYPE_DEBIT = 2;
   */
  DEBIT = 2,
}

/**
 * Describes the enum tenancy.v3.TransactionType.
 */
export const TransactionTypeSchema: GenEnum<TransactionType> = /*@__PURE__*/
  enumDesc(file_tenancy_v3_tenancy, 1);

/**
 * DebitType defines the different types of credit consumption
 *
 * @generated from enum tenancy.v3.DebitType
 */
export enum DebitType {
  /**
   * @generated from enum value: DEBIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEBIT_TYPE_INGESTION_EMBEDDINGS = 1;
   */
  INGESTION_EMBEDDINGS = 1,

  /**
   * @generated from enum value: DEBIT_TYPE_INGESTION_LLM_INPUT = 2;
   */
  INGESTION_LLM_INPUT = 2,

  /**
   * @generated from enum value: DEBIT_TYPE_INGESTION_LLM_OUTPUT = 3;
   */
  INGESTION_LLM_OUTPUT = 3,

  /**
   * @generated from enum value: DEBIT_TYPE_PROMPT_LLM_INPUT = 4;
   */
  PROMPT_LLM_INPUT = 4,

  /**
   * @generated from enum value: DEBIT_TYPE_PROMPT_LLM_OUTPUT = 5;
   */
  PROMPT_LLM_OUTPUT = 5,
}

/**
 * Describes the enum tenancy.v3.DebitType.
 */
export const DebitTypeSchema: GenEnum<DebitType> = /*@__PURE__*/
  enumDesc(file_tenancy_v3_tenancy, 2);

